export const XP_MARKET_STATUS = {
  Active: 0,
  Sold: 1,
  Canceled: 2,
};
